import React, { Component } from "react";

import "./Header.css";

import Button from "@material-ui/core/Button";
import { Menu } from "@material-ui/icons";
import { Drawer } from "@material-ui/core";

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drawerOpen: false,
      displayRoute: props.displayRoute,
    };
    this.routes = [
      {
        pageName: "About Us",
        pageUrl: "/about-us",
      },
      {
        pageName: "Constitution & Byelaws",
        pageUrl: "/constitution-byelaws",
      },
      {
        pageName: "Commitee",
        pageUrl: "/commitee",
      },
      {
        pageName: "Gallery",
        pageUrl: "/gallery",
      },
      {
        pageName: "Publications",
        pageUrl: "/publications",
      },
      {
        pageName: "Downloads",
        pageUrl: "/downloads",
      },
      {
        pageName: "Become a member",
        pageUrl: "/become-member",
      },
      // {
      //   pageName: "Elections",
      //   pageUrl: "/voting",
      // },
    ];
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.setState({ drawerOpen: false });
    }
  }

  navigateTo = (route) => {
    this.props.history.push(route);
    this.toggleDrawer(false);
  };

  toggleDrawer = (toggle) => {
    this.setState({ drawerOpen: toggle });
  };

  scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    this.setState({ drawerOpen: false });
  };

  render() {
    return (
      <header className="header">
        {/* <div className="nav-row-1">
          <div className="nav-logos">
            <img
              src="/logo-1.png"
              alt="ISN Logo"
            />
            <img
              src="/department_logo.png"
              alt="ISN Logo"
            />
          </div>
        </div> */}
        <div className="nav-row-2">
          <div className="nav-wrapper">
            {/* logo image */}
            <div className="logo" onClick={() => this.navigateTo("/")}>
              <img src="/logo.png" alt="logo" />
            </div>
            {/* nav links */}

            <nav className="nav-links">
              {this.routes.map((link) => (
                <Button
                  className={`link-btn ${link.pageName === "Elections" ? "elections-btn" : ""}`}
                  key={link.pageUrl}
                  onClick={() => this.navigateTo(link.pageUrl)}>
                  {link.pageName}
                </Button>
              ))}
            </nav>

            <div className="header-menu-bar">
              <Menu fontSize="large" onClick={() => this.toggleDrawer(true)} />
            </div>
            <Drawer anchor="right" open={this.state.drawerOpen} onClose={(e) => this.toggleDrawer(false)}>
              <div className="drawer-wrapper">
                <div className="drawer-content">
                  <img src="/logo.png" alt="logo" className="drawer-logo" onClick={() => this.navigateTo("/")} />
                  {this.routes.map((link) => (
                    <Button
                      className={`link-btn ${link.pageName === "Elections" ? "elections-btn" : ""}`}
                      key={link.pageUrl}
                      onClick={() => this.navigateTo(link.pageUrl)}>
                      {link.pageName}
                    </Button>
                  ))}
                </div>
              </div>
            </Drawer>
          </div>
        </div>
      </header>
    );
  }
}
